module.exports = __webpack_public_path__ + "static/img/dps03.de7dade5.png";